import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GuidSelectModel } from "services/api/cplapi/CPLAPI";
import { IBlocksService } from "services/BlocksService";
import { RootState } from "setup";
import { container } from "setup/dependency/inversify.config";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

const initialState = {
  BlockSelectModels: new Array<GuidSelectModel>(),
  Loading: false,
  LastUpdateTime: new Date(),
};

export const blockSelectSlice = createSlice({
  name: "blockSelect",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getBlockSelectModels.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getBlockSelectModels.rejected, (state) => {
        state.Loading = false;
      })
      .addCase(getBlockSelectModels.fulfilled, (state, action) => {
        state.BlockSelectModels = action.payload;
        state.Loading = false;
        state.LastUpdateTime = new Date();
      });
  },
});

export const getBlockSelectModels = createAsyncThunk(
  "Blocks/GetBlocksSelectModels",
  async (developmentIds?: string[]) => {
    const blocksService = container.get<IBlocksService>(SERVICE_TYPES.BlocksService);
    return await blocksService.getBlocksSelectModels(developmentIds);
  }
);

export const selectBlockSelectModels = (state: RootState) => {
  return state.blockSelect.BlockSelectModels;
};
export const selectLoading = (state: RootState) => {
  return state.blockSelect.Loading;
};
export const selectLastUpdateTime = (state: RootState) => {
  return state.blockSelect.LastUpdateTime;
};

export default blockSelectSlice.reducer;
